






















































































import JdsGlyph from "@/design-system/icons/JdsGlyph.vue";
import JdsNavigator from "@/design-system/patterns/Navigator/JdsNavigator.vue";
import JdsNavigatorFullPageLayout from "@/design-system/patterns/Navigator/JdsNavigatorFullPageLayout.vue";
import JdsNavigatorHeading from "@/design-system/patterns/Navigator/JdsNavigatorHeading.vue";
import JdsNavigatorItem from "@/design-system/patterns/Navigator/JdsNavigatorItem.vue";
import { Component, Ref, Vue } from 'vue-property-decorator';

@Component({
    components: { JdsNavigatorHeading, JdsGlyph, JdsNavigatorItem, JdsNavigatorFullPageLayout, JdsNavigator }
})
export default class JdpCompanySettings extends Vue {
    @Ref() layout!: JdsNavigatorFullPageLayout;

    closeNavigator() {
        this.layout.close()
    }
}
